import { render, staticRenderFns } from "./FantasyTutorialContainer.vue?vue&type=template&id=1b9b6d9d&scoped=true"
import script from "./FantasyTutorialContainer.vue?vue&type=script&lang=ts"
export * from "./FantasyTutorialContainer.vue?vue&type=script&lang=ts"
import style0 from "./FantasyTutorialContainer.vue?vue&type=style&index=0&id=1b9b6d9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9b6d9d",
  null
  
)

export default component.exports